import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { injectIntl, FormattedMessage } from 'react-intl';
import autoBind from 'react-autobind';

import ProfileSection from 'ui/users/profile-section';

import { trackGetBadgeClick } from 'store/features/badges/actions';
import { buildIPFSUrl } from 'utils/url';
import Loading from 'ui/common/loading';
import routeTemplates from 'ui/common/routes/templates';
import routeGenerators from 'ui/common/routes/generators';
import classnames from 'classnames';
import styles from './index.module.scss';

import { selectCurrentUserId } from 'store/features/auth/selectors';
import { selectUserById } from 'store/features/users/selectors';

export class Badges extends Component {
  constructor(props) {
    super(props);

    autoBind(this);
  }

  iconUrl(image) {
    if (!image) return '';
    const { iconIpfs, iconS3 } = image;
    if (iconS3) return `https://${image.iconS3}`;
    if (iconIpfs) return buildIPFSUrl(image.iconIpfs);
    return '';
  }

  alreadyEarnedThisBadge(badge) {
    const { currentUser } = this.props;
    if (badge && currentUser && currentUser.badges) {
      return currentUser.badges.filter(b => b.prettyId === badge.prettyId).length > 0;
    }
    return false;
  }

  renderCallToActionLink(badge) {
    const { member } = this.props;
    const { extensionsCtaLink, extensionsCtaText, prettyId, issuer } = badge;
    return (
      <span>
        {extensionsCtaLink && (issuer && !issuer.chatbotUuid) ? (
          <a
            className={classnames('btn btn-sm btn-primary')}
            href={extensionsCtaLink.link}
            onClick={() => this.props.trackGetBadgeClick(badge, member)}
          >
            {extensionsCtaText && extensionsCtaText.text}
          </a>
        ) : (
          <Link
            to={routeGenerators.badges.details({ prettyId })}
            className="btn btn-sm btn-primary"
          >
            {extensionsCtaText && extensionsCtaText.text}
          </Link>
        )}
      </span>
    );
  }

  renderBadgeEntry(badge, isPending = false) {
    if (badge) {
      const { onOwnProfile } = this.props;
      const alreadyEarned = onOwnProfile || this.alreadyEarnedThisBadge(badge);
      const { id, name, image } = badge;

      return (
        <div
          key={id}
          className={classnames(
            'col-6 col-md-3 d-flex flex-column justify-content-center align-items-center pb-3',
            styles.badgeItem,
            {
              [styles.pendingBadge]: isPending,
            }
          )}
        >
          {image && <img src={this.iconUrl(image)} className={styles.badgeImage} alt={name} />}
          <div className="py-2">{name}</div>
          {(!alreadyEarned || isPending) &&
            (badge.extensionsCtaLink &&
              badge.extensionsCtaLink.link &&
              badge.extensionsCtaText &&
              badge.extensionsCtaText.text) && (
              <div
                className={classnames(
                  'align-items-center justify-content-center',
                  styles.badgeOverlay
                )}
              >
                {this.renderCallToActionLink(badge)}
              </div>
            )}
        </div>
      );
    }
    return null;
  }

  renderPlusBtn() {
    return (
      <li key="add-btn" className={classnames('list-inline-item p-3', styles.badgeItem)}>
        <Link
          to={routeTemplates.validate}
          className={classnames('btn btn-sm btn-secondary', styles.xlBtn)}
        >
          <i className="fa fa-2x fa-plus" />
        </Link>
      </li>
    );
  }

  render() {
    const { member } = this.props;

    if (!member) return <Loading />;

    // const { badges, pendingBadges } = member;
    const { badges } = member;
    const badgesPresent = badges && badges.length > 0;
    const showSection = badgesPresent;

    if (!showSection) return null;

    return (
      <div className="row" id="badges">
        <ProfileSection
          title={<FormattedMessage id="user.badge.title" defaultMessage="Badges" />}
          collapsible
          className="col-12"
        >
          <div className="row pt-4 justify-content-center">
            {badges && badges.map(badge => this.renderBadgeEntry(badge))}
          </div>

          {/* TODO: Hiding pending badges until we figure out how to show and remove duplicate*/}
          {/* {pendingBadges &&
                    pendingBadges.map(pendingBadge => this.renderBadgeEntry(pendingBadge, true))} */}
          {/*ImpressAIValidationEnabled && onOwnProfile && this.renderPlusBtn()*/}
        </ProfileSection>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const currentUserId = selectCurrentUserId(state);
  const currentUser = currentUserId ? selectUserById(state, { id: currentUserId }) : null;
  const onOwnProfile = currentUserId && currentUserId === ownProps.member.id;

  return {
    currentUserId,
    onOwnProfile,
    currentUser,
  };
}

const mapDispatchToProps = {
  trackGetBadgeClick,
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Badges));
